<template>
  <div class="dialog_content">
    <!-- <div class="filtrate">
      <el-input
        v-model="input"
        placeholder="请输入内容"
        style="margin-left:10px;width:300px"
      >
        <el-button type="primary" slot="append">搜索</el-button>
      </el-input>
    </div> -->
    <div class="table">
      <el-table :data="mallList" height="100%">
        <el-table-column label="商品">
          <template slot-scope="scope">
            <div class="mallImage">
              <img :src="scope.row.imgUrl" alt="" />
              <div>{{ scope.row.name }}</div>
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="address" label="操作" width="80">
          <template slot-scope="scope">
            <el-button size="small" @click="selectRow(scope.row)"
              >选择</el-button
            >
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="page">
      <el-pagination
        layout="prev, pager, next, total, jumper"
        :current-page="page"
        :total="total"
        :page-size="10"
        @current-change="handleCurrentChange"
      >
      </el-pagination>
    </div>
  </div>
</template>

<script>
import { getComList } from "@/api/mall";
import { couponList } from "@/api/coupon";
import { mapGetters } from "vuex";
export default {
  computed: {
    ...mapGetters(["token", "app_id"])
  },
  props:{
    jude: {
      // 0 普通商品 2 优惠券
      type: Number,
      default: 0
    },
  },
  data() {
    return {
      input: "",
      page: 1,
      total: 0,
      mallList: [],
      tableData: []
    };
  },
  mounted() {
    this.getComLists();
  },
  watch:{
    jude: {
      handler: function(val) {
        this.getComLists();
      },
      deep: true
    }
  },
  methods: {
    selectRow(row) {
      console.log(row);
      var data = {
        id: row.id,
        name: row.name
      };
      this.$emit("getCommod", data);
      this.closePage();
    },
    closePage() {
      this.$emit("close");
    },
    getComLists() {
      let data = {
        token: this.token,
        app_id: this.app_id,
        page: this.page
      };
      if(this.jude == 0){
        getComList(data).then(res => {
          console.log(res);
          this.mallList = res.data;
          this.total = res.total;
        });
      }else if(this.jude == 2){
        data.is_exp = 0;
        couponList(data).then(res => {
          console.log(res);
          if(res.code == 200){
            this.total = res.data.total_num;
            let data = res.data.result;
            data.forEach(item => {
              var obj = {};
              obj.name = item.title;
              obj.imgUrl = item.share_pic;
              obj.id = item.id;
              this.mallList.push(obj);
            })
            console.log('选项',this.mallList)
            // for (var i = 0; i < data.length; i++) {
            //   let obj = {};
            //   obj.name = data[i].title;
            //   obj.imgUrl = data[i].share_pic;
            //   obj.id = data[i].id;
            //   this.mallList.push(obj);
            // }
          }
        });
      }
    },
    handleCurrentChange(p) {
      this.page = p;
      this.getComLists();
    },
  }
};
</script>

<style lang="scss" scoped>
.dialog_content {
  width: 100%;
  padding: 0;
  .filtrate {
    text-align: right;
  }
  .table {
    margin-top: 10px;
    height: 500px;
    .mallImage {
      display: flex;
      flex-direction: row;
      img {
        width: 50px;
        height: 50px;
      }
      div {
        flex: 1;
        margin-left: 10px;
        line-height: 50px;
      }
    }
  }
  .page {
    height: 30px;
  }
}
</style>
